import { Filter } from '@/interfaces/filter.interface'
import { APIShortcode } from '@/models/api/shortcode.model'
import { ShortcodesServices } from '@/services/modules/shortcodes.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ShortcodesStore extends VuexModule {
    shortcodes: object[] = []
    shortcodesPaginate: object[] = []
    shortcodeForm: object|null = null

    @Mutation
    updateShortcodes (newShortcodes: object[]) {
        this.shortcodes = newShortcodes
    }

    @Mutation
    updateShortcodesPaginate (newShortcodes: object[]) {
        this.shortcodesPaginate = newShortcodes
    }

    @Mutation
    updateShortcode (newShortcode: object) {
        this.shortcodeForm = newShortcode
    }

    @Action
    getShortcodes () {
        return new Promise((resolve) => {
            ShortcodesServices.getShortcodes()
                .then(resp => {
                    store.commit('updateShortcodes', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getShortcodesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ShortcodesServices.getShortcodesPaginate(newParams)
                .then(resp => {
                    store.commit('updateShortcodesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getShortcodesById (id: number) {
        return new Promise((resolve) => {
            ShortcodesServices.getShortcodesById(id)
                .then(resp => {
                    store.commit('updateShortcode', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editShortcodes (params: APIShortcode) {
        params = new APIShortcode(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIShortcode)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ShortcodesServices.editShortcodes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createShortcodes (params: APIShortcode) {
        params = new APIShortcode(params)

        params.shortcodeEnabled = 1

        return new Promise((resolve) => {
            if (!(params instanceof APIShortcode)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ShortcodesServices.createShortcodes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteShortcodes (id: number) {
        return new Promise((resolve) => {
            ShortcodesServices.deleteShortcodes(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreShortcodes (id: number) {
        return new Promise((resolve) => {
            ShortcodesServices.restoreShortcodes(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
